/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MediaMinimal } from './MediaMinimal';
import {
    MediaMinimalFromJSON,
    MediaMinimalFromJSONTyped,
    MediaMinimalToJSON,
    MediaMinimalToJSONTyped,
} from './MediaMinimal';
import type { Persona } from './Persona';
import {
    PersonaFromJSON,
    PersonaFromJSONTyped,
    PersonaToJSON,
    PersonaToJSONTyped,
} from './Persona';
import type { ChatMessage } from './ChatMessage';
import {
    ChatMessageFromJSON,
    ChatMessageFromJSONTyped,
    ChatMessageToJSON,
    ChatMessageToJSONTyped,
} from './ChatMessage';

/**
 * 
 * @export
 * @interface PrivateNote
 */
export interface PrivateNote {
    /**
     * Unique identifier of the private note
     * @type {string}
     * @memberof PrivateNote
     */
    id: string;
    /**
     * The text content of the private note
     * @type {string}
     * @memberof PrivateNote
     */
    text: string;
    /**
     * List of media attachments for this note
     * @type {Array<MediaMinimal>}
     * @memberof PrivateNote
     */
    attachments: Array<MediaMinimal>;
    /**
     * The chat message this note is related to, if any
     * @type {ChatMessage}
     * @memberof PrivateNote
     */
    relatedMessage?: ChatMessage;
    /**
     * Current status of the private note
     * @type {string}
     * @memberof PrivateNote
     */
    status: PrivateNoteStatusEnum;
    /**
     * The persona that authored this note
     * @type {Persona}
     * @memberof PrivateNote
     */
    author?: Persona;
    /**
     * The time this note was created
     * @type {Date}
     * @memberof PrivateNote
     */
    createdAt: Date;
}


/**
 * @export
 */
export const PrivateNoteStatusEnum = {
    Active: 'ACTIVE',
    Handled: 'HANDLED',
    Archived: 'ARCHIVED',
    Deleted: 'DELETED'
} as const;
export type PrivateNoteStatusEnum = typeof PrivateNoteStatusEnum[keyof typeof PrivateNoteStatusEnum];


/**
 * Check if a given object implements the PrivateNote interface.
 */
export function instanceOfPrivateNote(value: object): value is PrivateNote {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('attachments' in value) || value['attachments'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function PrivateNoteFromJSON(json: any): PrivateNote {
    return PrivateNoteFromJSONTyped(json, false);
}

export function PrivateNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrivateNote {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'text': json['text'],
        'attachments': ((json['attachments'] as Array<any>).map(MediaMinimalFromJSON)),
        'relatedMessage': json['relatedMessage'] == null ? undefined : ChatMessageFromJSON(json['relatedMessage']),
        'status': json['status'],
        'author': json['author'] == null ? undefined : PersonaFromJSON(json['author']),
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function PrivateNoteToJSON(json: any): PrivateNote {
    return PrivateNoteToJSONTyped(json, false);
}

export function PrivateNoteToJSONTyped(value?: PrivateNote | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'text': value['text'],
        'attachments': ((value['attachments'] as Array<any>).map(MediaMinimalToJSON)),
        'relatedMessage': ChatMessageToJSON(value['relatedMessage']),
        'status': value['status'],
        'author': PersonaToJSON(value['author']),
        'createdAt': value['createdAt'].toISOString(),
    };
}

